export default () => ({
    msg: "",
    errorInfo: ""
});
